import React from 'react';

import HeaderBase from './Header';

const Header = props => {
  return <HeaderBase {...props} />;
};

export default Header;
